import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IBaseService, SingleResponseModel } from 'src/app/tabms/models/base/base';

@Component({
  selector: 'app-base-view',
  templateUrl: './base-view.component.html',
  styleUrl: './base-view.component.scss'
})
export class BaseViewComponent<T> implements OnInit {
  fieldsConfigService;
  serviceInstance;//: IBaseService<T>;
  viewId;
  viewData;
  detailsArr;
  dataColumns;
  hasDetails: boolean = true;
  detailsColumns;
  // constructor
  constructor(@Inject(MAT_DIALOG_DATA) public data) {
    this.serviceInstance = data.service;
    this.viewId = data.id;
    this.fieldsConfigService = data.fieldsConfigService;
  }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.serviceInstance.get(this.viewId).subscribe((res:SingleResponseModel<T>)=>{
      this.viewData = res.result;
     });
    
    this.dataColumns = this.fieldsConfigService.getDisplayColumns();
    if (this.hasDetails) {
      this.detailsArr = this.serviceInstance.getDetails();
      this.detailsArr = this.detailsArr[0];
      this.detailsColumns = this.fieldsConfigService.getDisplayColumns();
    }
  }

}
